const data = {
  title: "",
  description: "",
  font_color: "",
  bg_color: "#f1f1f1",
  form_fields: [
    {
      label: "Candidate First Name",
      placeholder: "First Name",
      type: "text",
      name: "first_name",
      required: true,
    },
    {
      label: "Candidate Last Name",
      placeholder: "Last Name",
      type: "text",
      name: "last_name",
      required: false,
    },
    {
      label: "Candidate Email",
      placeholder: "Candidate Email",
      type: "email",
      name: "email",
      required: true,
    },
    {
      label: "Password",
      placeholder: "Password",
      type: "Password",
      name: "password",
      required: true,
    },

    {
      label: "Phone Number",
      placeholder: "Phone Number",
      type: "text",
      name: "phone_number",
      required: false,
    },
    {
      label: "Address",
      placeholder: "Address",
      type: "text",
      name: "address",
      required: false,
    },
  ],
  submit_btn: {
    text: "Register",
    font_color: "#fff",
    bg_color: "rgb(75,96,107)",
    api: "",
  },
};

export default data;
